var _a;
export var BRAZE = {
    SUBSCRIPTION_TYPES: {
        OPTED_IN: 'opted_in',
        SUBSCRIBED: 'subscribed',
        UNSUBSCRIBED: 'unsubscribed'
    },
    SUBSCRIPTION_STATUS: {
        subscribed: 'subscribed'
    },
    EVENTS: {
        initialize: 'braze:initialized',
        subscribed: 'braze:subscribed',
        enteredCheckout: 'braze:emailEnteredCheckout',
        addToBag: 'braze:addToBag',
        updateQuantity: 'braze:updatedQuantity',
        removedFromCart: 'braze:removedFromCart',
        viewPLP: 'braze:viewPlp',
        viewPDP: 'braze:viewPdp'
    }
};
export var BRAZE_LOG_EVENTS = (_a = {},
    _a[BRAZE.EVENTS.addToBag] = 'add_to_bag',
    _a[BRAZE.EVENTS.updateQuantity] = 'updated_quantity',
    _a[BRAZE.EVENTS.removedFromCart] = 'removed_from_cart',
    _a[BRAZE.EVENTS.viewPLP] = 'view_plp',
    _a[BRAZE.EVENTS.viewPDP] = 'view_pdp',
    _a);
export var SUBSCRIPTION_STATUS = {
    optionId: 'subscriptionStatus',
    subscribed: 'subscribed',
    notSubscribed: 'not_subscribed'
};
//# sourceMappingURL=index.js.map